import { jsx as _jsx } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgIconTag = (props, ref) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      d: 'm5.567 4.157 1.288 1.286a3 3 0 1 1-1.413 1.415L4.157 5.576v5.464l9.108 9.125 6.9-6.9-9.125-9.108H5.567Zm-1.41-2h6.883a2 2 0 0 1 1.413.585l9.125 9.108a2 2 0 0 1 .001 2.83l-6.9 6.9a2 2 0 0 1-2.829-.002l-9.108-9.125a2 2 0 0 1-.585-1.413V4.157a2 2 0 0 1 2-2ZM8.15 7.15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
      clipRule: 'evenodd',
    }),
  })
const ForwardRef = forwardRef(SvgIconTag)
export default ForwardRef
